import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { PhoneIcon, CheckIcon } from '@heroicons/react/outline'


export default function Section1() {
  return (
    <div className="relative bg-white overflow-hidden">
      <main className="lg:mx-auto lg:max-w-7xl lg:pb-16 lg:relative">
        <svg
          className="z-10 hidden lg:block absolute inset-y-0 h-full w-48 text-white transform right-1/2"
          fill="currentColor"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <polygon points="50,0 100,0 100,100 95,100" />
        </svg>
        <div className="hidden mx-auto lg:w-160 text-right lg:text-left lg:block object-cover lg:max-h-80 lg:min-h-80">
          <StaticImage
            className="mx-auto inset-0 w-600 h-full object-cover"
            src="../../images/equipe-professionnel-plombier-urgence-blicko-pro.jpeg"
            alt="Equipe blicko"
          />
        </div>
        <div className="bg-white relative w-full sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full">
          <div className="m-4 pt-4 lg:pt-4 sm:text-center md:max-w-2xl lg:ml-8 lg:col-span-6 lg:text-left lg:w-120">
            <h1>
              <span className="mt-1 block text-3xl tracking-tight font-extrabold sm:text-3xl xl:text-4xl">
                <span className="block text-gray-900">Plombiers à Lyon,<br /> Villeurbanne et alentours.</span>
                <span className="block text-[#3333e6]">RDV rapide.</span>
              </span>
            </h1>
            <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
              Créez votre Espace de Diagnostic en 1 clic, puis déposez votre demande 24h/24 avec une vidéo du problème.
            </p>
            <div className="mt-1 space-y-1">
              <div className="relative flex items-start">
                <CheckIcon className="h-6 w-6 text-[#3333e6] flex-shrink-0" aria-hidden="true" />
                <p className="ml-3 text-base text-gray-700">Traitement prioritaire → devis transmis dans la demi-journée suivante</p>
              </div>
              <div className="relative flex items-start">
                <CheckIcon className="h-6 w-6 text-[#3333e6] flex-shrink-0" aria-hidden="true" />
                <p className="ml-3 text-base text-gray-700">Réponse précise, gratuite et rapide de notre bureau</p>
              </div>
            </div>
            <div className="mt-2 flex justify-center">
              <a
                href="https://app.blicko.fr/login"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-2xl shadow-xl rounded-xl"
                style={{ boxShadow: '0 15px 35px -5px rgba(0, 0, 0, 0.5), 0 10px 15px -3px rgba(0, 0, 0, 0.4)' }}
              >
                <StaticImage
                  src="../../images/blicko-app.png"
                  alt="Blicko App"
                  className="w-full"
                  style={{ borderRadius: '10px' }}
                />
              </a>
            </div>
          </div>
        </div>
      </main>



    </div>
  )
}



